import { render, staticRenderFns } from "./SquizzySquid.vue?vue&type=template&id=23cac820&scoped=true&"
import script from "./SquizzySquid.vue?vue&type=script&lang=js&"
export * from "./SquizzySquid.vue?vue&type=script&lang=js&"
import style0 from "./SquizzySquid.vue?vue&type=style&index=0&id=23cac820&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cac820",
  null
  
)

export default component.exports